import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Loading from '../components/Loading'
import GcpOnboardForm from './GcpOnboardForm'
import { registerOrganization } from '../../../rest'
import { Card } from '../components/styles'
import {
  ROUTES
} from '../../../lib'

class GcpSelfOnboardForm extends Component {
  state = {
    isLoading: true,
    isFormLoading: false,
    // data does not change
    email: '',
    practiceName: '',

    // data that needs to be sent
    phoneNumber: '',
    emr: '',
    timezone: '',

    accountid: null // gcpMarketplaceId
  }

  componentDidMount () {
    // get param values
    const { history } = this.props
    const queryParams = new URLSearchParams(this.props.location.search)
    const gcpMarketplaceId = queryParams.get('accountid')

    // if email or token DNE, error out
    if (!gcpMarketplaceId) {
      history.push(ROUTES.HOME)
      return
    }

    this.setState({ isLoading: false, accountid: gcpMarketplaceId })
  }

  onFormCompletion = (values) => {
    const { history } = this.props

    const { accountid } = this.state
    const formValues = { ...values, accountid }

    this.setState({ isFormLoading: true })
    registerOrganization(formValues).then((res) => {
      this.setState({ isFormLoading: false })

      const { status } = res
      if (status === 200) {
        history.push(ROUTES.GCP_REGISTER_SUCCESS)
      } else {
        history.push(ROUTES.GCP_REGISTER_ERROR)
      }
    })
  }

  render () {
    const {
      email,
      practiceName,
      phoneNumber,
      isFormLoading,
      isLoading,
      accountid
    } = this.state

    if (isLoading) {
      return <Loading />
    }

    return (
      <Card>
        <GcpOnboardForm
          initialValues={{
            email,
            practiceName,
            phoneNumber
          }}

          isFromGCP={!!accountid}
          isPracticePrefilled={!!practiceName}
          isFormLoading={isFormLoading}
          handleFormCompletion={this.onFormCompletion}
        />
      </Card>
    )
  }
}

export default withRouter(GcpSelfOnboardForm)
